import { Button, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAnalytics } from "src/hooks/analytics.hook";
type ModalProps = {
  isModalOpen?: boolean;
  closeModal?: any;
};

const btnClass =
  "w-[120px] h-[120px] md:w-[200px] md:h-[200px] flex items-center justify-center wrap w-full";

export const NewtransactionModal: React.FC<ModalProps> = ({
  isModalOpen,
  closeModal,
}) => {
  const buyUrl = process.env.REACT_APP_BUY_ORDER_URL || "";
  const sellUrl = process.env.REACT_APP_SELL_ORDER_URL || "";
  const { t } = useTranslation("transactions");
  const { track } = useAnalytics();

  useEffect(() => {
    if (isModalOpen) {
      track("Pop-up", {
        page_current: "my_transactions",
        popup_name: "transaction_new",
      });
    }
  }, [isModalOpen]);

  const onClick = (event: string) => {
    track(event);
  };

  return (
    <Modal
      title={t("newTransactionLabel")}
      open={isModalOpen}
      onCancel={() => closeModal()}
      footer={<></>}
    >
      <h1 className="text-xl mt-5">{t("transactionTypeChooseLabel")}</h1>
      <div className="flex justify-center gap-4 items-center w-full mt-10">
        <Link to={buyUrl} target="_blank">
          <Button className={btnClass} onClick={() => onClick("form_buy")}>
            <img
              src="/icons/buy.png"
              alt="buy"
              className="w-[30px] h-[30px] md:h-[50px] md:w-[50px]  mr-2"
            />
            <span className="md:text-lg text-md">{t("buy")}</span>
          </Button>
        </Link>
        <Link to={sellUrl} target="_blank">
          <Button className={btnClass} onClick={() => onClick("form_sale")}>
            <img
              src="/icons/sell.png"
              alt="sell"
              className="w-[30px] h-[30px] md:h-[50px] md:w-[50px] mr-2"
            />
            <span className="md:text-lg text-md">{t("sell")}</span>
          </Button>
        </Link>
      </div>
    </Modal>
  );
};
